import { SensorSlot } from "../../../../types/types";
import DeviceNetworkSensorData from "./DeviceNetworkSensorData";
import DeviceSensorData from "./DeviceSensorData";

const DeviceSlotDebug = ({ slot, selectedDate }: { slot: SensorSlot; selectedDate: { from: Date; to: Date } }) => {

  const networkSensor = slot.sensors.filter(
    (s) => !["rfid"].includes(s.sensor_type.data_key_name)
  )[0];

  return (
    networkSensor && (
      <div className="flex flex-col space-y-4">
        <DeviceNetworkSensorData sensor={networkSensor} selectedDate={selectedDate} />
        {slot.sensors
          .filter((s) => !!["ac_min", "ac_max", "ac_avg"].includes(s.sensor_type.data_key_name))
          .map((sensor) =>
            sensor ? <DeviceSensorData key={sensor.id} sensor={sensor} sensorId={String(sensor.id)} selectedDate={selectedDate} /> : <></>
          )}
      </div>
    )
  );
};

export default DeviceSlotDebug;
